import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckoutListEventPriceComponent } from './checkout-list-event-price.component';

@NgModule({
    declarations: [CheckoutListEventPriceComponent],
    exports: [CheckoutListEventPriceComponent],
    imports: [CommonModule]
})
export class CheckoutListEventPriceModule {}
